import React from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { FaIcon as Fa } from "lib/FaIcon";
import { _t } from "../../app/i18n/i18n";

export function DownloadPdfPopout({ show, filename, error, onFilenameChange, onCancel, onSubmit }) {
  return (
    <Modal show={show} onHide={onCancel} style={{ zIndex: 2000 }}>
      <Modal.Header closeButton>
        <Modal.Title>{_t("Save PDF")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <Form.Group>
            <Form.Label>
              {_t("Enter file name")}
              {error && (
                <span style={{ marginLeft: 8, color: "red" }}>
                  <Fa icon="fa fa-info-circle" />
                </span>
              )}
            </Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                value={filename}
                onChange={onFilenameChange}
                placeholder="File name"
                isInvalid={!!error}
                maxLength={255}
              />
              <InputGroup.Text>.pdf</InputGroup.Text>
            </InputGroup>
            {error && <div className="text-danger mt-1">{error}</div>}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {_t("Cancel download")}
        </Button>
        <Button variant="primary" onClick={onSubmit} disabled={!filename || !!error}>
          {_t("Download")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
